import Glide from '@glidejs/glide'

const enableGlideJs = function() {
	const glideCarouselWrapper = document.querySelector('.glide');
	if (glideCarouselWrapper !== null) {
		new Glide('.glide').mount();
	}
	
	const articlePageCarouselWrapper = document.querySelector('.glide-article-page');
	if (articlePageCarouselWrapper !== null) {
		new Glide('.glide-article-page').mount();
	}
}

export default enableGlideJs;